import styled from 'styled-components/macro';

const TagWrapper = styled.li`
  position: relative;
  margin: 1rem;
`;

export default TagWrapper;
